export const ROLES = ['SUPER_ADMIN', 'ADMIN', 'USER'];
export const USER_STATUSES = ['PENDING_ACTIVATION', 'ACTIVE', 'ON_HOLD', 'SUSPENDED'];
/**
 * Statuses that stop everything: no login, no mailbox syncing, no link
 * visiting. ON_HOLD is the reversible one an admin applies; SUSPENDED is the
 * harder stop.
 */
export const HALTED_STATUSES = ['ON_HOLD', 'SUSPENDED'];
export const TIERS = ['FREE', 'STARTER', 'PRO', 'ENTERPRISE'];
export const SYNC_STATUSES = [
    'NEVER_SYNCED',
    'SYNCING',
    'OK',
    'AUTH_FAILED',
    'CONNECTION_ERROR',
    'DISABLED',
];
export const VISIT_STATUSES = ['PENDING', 'IN_PROGRESS', 'SUCCESS', 'FAILED', 'SKIPPED'];
export const VISIT_METHODS = ['HTTP', 'BROWSER'];
export const ERROR_CATEGORIES = [
    'DNS',
    'TLS',
    'TIMEOUT',
    'CONNECTION',
    'HTTP_4XX',
    'HTTP_5XX',
    'BLOCKED',
    'NAVIGATION',
    'TOO_LARGE',
    'UNKNOWN',
];
/**
 * Login identifier format handed to users: NLK-XXXX-XXXX.
 * Crockford-style alphabet — no I, L, O, U, 0, 1 — so codes read cleanly over
 * the phone and survive being written down by hand.
 */
export const UID_PREFIX = 'NLK';
export const UID_ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ';
export const UID_GROUP_LENGTH = 4;
export const UID_GROUPS = 2;
export const UID_REGEX = /^NLK-[23456789ABCDEFGHJKMNPQRSTVWXYZ]{4}-[23456789ABCDEFGHJKMNPQRSTVWXYZ]{4}$/;
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 200;
/** Queue names. Shared so API and worker can never drift apart. */
export const QUEUE_MAIL_SYNC = 'nlinks.mail-sync';
export const QUEUE_LINK_VISIT = 'nlinks.link-visit';
export const QUEUE_MAINTENANCE = 'nlinks.maintenance';
/** Server-sent event channel names. */
export const SSE_EVENTS = {
    SYNC_STARTED: 'sync.started',
    SYNC_COMPLETED: 'sync.completed',
    SYNC_FAILED: 'sync.failed',
    MESSAGE_INGESTED: 'message.ingested',
    VISIT_COMPLETED: 'visit.completed',
};
//# sourceMappingURL=constants.js.map